import data__img1 from "../assets/img/swiper-img1.jpg";
import data__img2 from "../assets/img/swiper-img2.jpg";
import data__img3 from "../assets/img/swiper-img3.jpg";
import data__img4 from "../assets/img/swiper-img4.jpg";
import data__img5 from "../assets/img/swiper-img5.jpg";
import data__img6 from "../assets/img/swiper-img6.jpg";
import data__img7 from "../assets/img/swiper-img7.jpg";
import data__img8 from "../assets/img/swiper-img8.jpg";
import data__img9 from "../assets/img/swiper-img9.jpg";
import data__img10 from "../assets/img/swiper-img10.jpg";
import data__img11 from "../assets/img/swiper-img11.jpg";
import data__img12 from "../assets/img/swiper-img12.jpg";
import data__img13 from "../assets/img/swiper-img13.jpg";
import data__img14 from "../assets/img/swiper-img14.jpg";
import data__img15 from "../assets/img/swiper-img15.jpg";
import data__img16 from "../assets/img/swiper-img16.jpg";
import data__img17 from "../assets/img/swiper-img17.jpg";
import data__img18 from "../assets/img/swiper-img18.jpg";
export let swiper = [
    {
        id: 1,
        image: data__img1
    },
    {
        id: 2,
        image: data__img2
    },
    {
        id: 3,
        image: data__img3
    },
    {
        id: 4,
        image: data__img4
    },
    {
        id: 5,
        image: data__img5
    },
    {
        id: 6,
        image: data__img6
    },
    {
        id: 7,
        image: data__img7
    },
    {
        id: 8,
        image: data__img8
    },
    {
        id: 9,
        image: data__img9
    },
    {
        id: 10,
        image: data__img10
    },
    {
        id: 11,
        image: data__img11
    },
    {
        id: 12,
        image: data__img12
    },
    {
        id: 13,
        image: data__img13
    },
    {
        id: 14,
        image: data__img14
    },
    {
        id: 15,
        image: data__img15
    },
    {
        id: 16,
        image: data__img16
    },
    {
        id: 17,
        image: data__img17
    },
    {
        id: 18,
        image: data__img18
    },

]
